/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import ThunderIcon from '../icons/thunder.svg'

/**
 * Extracted "search / filters" section from board.jsx without changing any UI or logic.
 * It expects the parent to pass down all state/handlers it previously used inline.
 */
export default function SearchSection({
  showMobileFilters,
  setShowMobileFilters,
  searchInput,
  onSearchChanged,
  FilterSelect,
  sortOptions,
  sortValue,
  onSortChange,
  statusOptions,
  statusValue,
  onStatusChange,
  chainOptions,
  chainValue,
  onChainChange,
  buyAmount,
  setBuyAmount,
  onResetFilters,
  orderValue,
  onOrderChange,
  liveBuzzEnabled,
  setLiveBuzzEnabled
}) {
  return (
    <div
      className={`mt-3 mb-3 rounded-lg border border-[#2a2d36] bg-[#171a21] p-3 ${
        showMobileFilters ? 'pb-3' : 'pb-3'
      } relative`}
    >
      <div
        className={`relative flex flex-wrap items-center gap-3 md:gap-4 ${
          showMobileFilters ? 'mb-3 sm:mb-4' : 'mb-0'
        } w-full`}
      >
        <svg
          fill="#c5c5c0"
          viewBox="0 0 18 18"
          width="18"
          className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none z-10"
        >
          <g>
            <path d="M7.75987 15.5197C3.48078 15.5197 0 12.039 0 7.75987C0 3.48078 3.48078 0 7.75987 0C12.039 0 15.5197 3.48078 15.5197 7.75987C15.5197 12.039 12.039 15.5197 7.75987 15.5197ZM7.75987 1.90911C4.53381 1.90911 1.90911 4.53381 1.90911 7.75855C1.90911 10.9833 4.53381 13.608 7.75987 13.608C10.9859 13.608 13.6106 10.9833 13.6106 7.75855C13.6106 4.53381 10.9859 1.91042 7.75987 1.91042V1.90911Z" />
            <path d="M16.8235 17.9987C16.5228 17.9987 16.2221 17.8845 15.9924 17.6547L11.9378 13.6001C11.4783 13.1406 11.4783 12.3974 11.9378 11.9379C12.3974 11.4783 13.1418 11.4783 13.6001 11.9379L17.6546 15.9924C18.1142 16.452 18.1142 17.1951 17.6546 17.6547C17.4249 17.8845 17.1242 17.9987 16.8235 17.9987Z" />
          </g>
        </svg>
        <input
          type="text"
          value={searchInput}
          onChange={onSearchChanged}
          placeholder="search coin"
          className="w-full h-9 rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px] text-[#f8ffe8] placeholder:text-[#fff]/40 pl-10 pr-4 focus:outline-none focus:ring-1 focus:ring-[#a135bb]"
        />
      </div>

      <div className="sm:hidden absolute right-3 top-3 m-0 z-20">
        <button
          onClick={() => setShowMobileFilters(!showMobileFilters)}
          className="inline-flex items-center gap-2 px-3 py-1 rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8] hover:bg-[#2a2d36] text-[12px]"
        >
          <span>{showMobileFilters ? 'hide' : 'filters'}</span>
        </button>
      </div>

      <div
        className={`${'flex flex-wrap items-center gap-2 sm:gap-3 md:gap-4 mt-3 w-full'} ${
          showMobileFilters ? '' : 'hidden'
        } sm:flex`}
      >
        <FilterSelect
          options={sortOptions}
          defaultValue={sortValue}
          onChange={onSortChange}
        />
        <FilterSelect
          options={statusOptions}
          defaultValue={statusValue}
          onChange={onStatusChange}
        />
        <FilterSelect
          options={chainOptions}
          defaultValue={chainValue}
          onChange={onChainChange}
        />

        <div className="flex items-center gap-2 rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/90 px-3 py-1 hover:bg-[#2a2d36] text-[12px]">
          <div className="flex items-center gap-1 text-[#f500ff]">
            <img src={ThunderIcon} alt="buy" width={16} />
            <span className="font-semibold">buy</span>
            <span className="text-white">:</span>
          </div>
          <div className="flex items-center gap-1">
            <span className="text-white font-bold">$</span>
            <input
              type="number"
              value={buyAmount}
              onChange={e => {
                const val = parseFloat(e.target.value)
                setBuyAmount(val >= 0 ? e.target.value : '0')
              }}
              className="w-14 h-5 text-right rounded-lg border border-[#2a2d36] bg-[#171a21] text-[#f8ffe8] placeholder:text-[#f8ffe8]/40 px-2 py-1 focus:outline-none focus:ring-2 focus:ring-[#a135bb]/30"
            />
          </div>
        </div>
        <button
          type="button"
          onClick={onResetFilters}
          className="ml-auto inline-flex justify-center items-center h-6 rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/90 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px] px-3 text-[12px]"
        >
          reset
        </button>
        <button
          onClick={onOrderChange}
          className="inline-flex justify-center items-center h-6 rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/90 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px] px-3 text-[12px]"
        >
          {orderValue.label === 'Ascending' ? 'asc' : 'desc'}
        </button>
        <button
          type="button"
          onClick={() => setLiveBuzzEnabled(v => !v)}
          aria-pressed={liveBuzzEnabled}
          className={`hk-buzz inline-flex justify-center items-center h-9 rounded-lg border px-3 text-[12px] gap-2 transition-colors hover:translate-y-[-1px] ${
            liveBuzzEnabled
              ? 'border-[#a135bb] bg-[#2a2d36] text-[#f8ffe8]'
              : 'border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/90 hover:bg-[#2a2d36] hover:border-[#a135bb]'
          }`}
          title="When ON: new buys jump to the top and glow"
        >
          <span className="hidden sm:inline">live bump</span>
          <span className="sm:hidden">bump</span>
          <span
            className={`inline-block w-2 h-2 rounded-full ${
              liveBuzzEnabled ? 'bg-[#a135bb]' : 'bg-white/30'
            }`}
          />
        </button>
      </div>
    </div>
  )
}
